import DashboardSettingsModal from './DashboardSettingsModal';

export default DashboardSettingsModal;
